import Component from "../../shared/component.abstract"


interface Group {
    opener: Element,
    parent: any
} 


export default class RadioToggle extends Component {

    sidenavOpener:any = [];
    constructor(private props: unknown, element: HTMLElement){
        super(props, element)
    }

    mounted(): void {
            if (this.element.getAttribute("id")) {
                const labels = document.querySelectorAll('label[for="' + this.element.getAttribute("id") + '"]');
                for (let l = 0; l < labels.length; l++) {
                    this.sidenavOpener.push({
                        opener : labels[l],
                        parent : this.element
                    })
                }
            } 
        
        for (const d in this.sidenavOpener) {
            this.sidenavOpen(this.sidenavOpener[d]);
        }
    }

    sidenavOpen(group: Group):void {
        group.opener.addEventListener("click", (e) => {
            if (group.parent.checked) {
                for (const g in this.sidenavOpener) {
                    this.sidenavOpener[g].parent.checked = false;
                }
                e.preventDefault();
                e.stopPropagation();
            } else {
                for (const g in this.sidenavOpener) {
                    this.sidenavOpener[g].parent.checked = false;
                }
                group.parent.checked = true;
                e.preventDefault();
                e.stopPropagation();
            }
        })
    }


}